import React, { Component } from 'react';
import { Link } from 'react-router'
import { Navbar, Image } from 'react-bootstrap';
import logo from '../../images/logo.png';

class NavHeader extends Component {

  render() {
    return (
      <Navbar.Header>
        <Navbar.Brand>
          <Link to="/">
            <div>
              <Image alt="Logo" style={{height:30, width:30, padding:0}} src={logo} thumbnail responsive />&nbsp;
              Fantasy Fitness Draft
            </div>
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
    );
  }

}

export default NavHeader;



// WEBPACK FOOTER //
// ./src/components/Navbar/NavHeader.js